
import { Component, Vue, Watch } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user";

@Component({
    name: "App"
})
export default class extends Vue {
    private created() {
        if (UserModule.token) {
            UserModule.InitSocket();
            // UserModule.GetChatsNum();
        }
    }

    get orderMessage(){
        return UserModule.orderMessage;
    }

    get otherPush(){
        return UserModule.otherPush;
    }

    @Watch('orderMessage') getNewOrder(){
        if(this.orderMessage && this.orderMessage.order){
            this.notifyOrder();
        }
    }
    @Watch('otherPush') getNewPush(){
        if(this.otherPush && this.otherPush.type && this.otherPush[this.otherPush.type]){
            let route = this.otherPush[this.otherPush.type]?.route  ? this.otherPush[this.otherPush.type]?.route : 'quick-index';
            let myAid = this.otherPush.myAid || 0;
            (this as any).$bus.$emit(route + '-refresh', {
                ...this.otherPush[this.otherPush.type],
                myAid:myAid,
            });
        }
    }

    notifyOrder(){
        let that = (this as any);
        const h = this.$createElement;
        let notify = this.$notify({
            title: that.orderMessage.title,
            message: h('div',{},[
                h('p',{style:{paddingBottom:'20px',fontSize:'14px',color:'#4e5669'}},that.orderMessage.desc),
                h('el-button',{attrs:{type:'primary',id:'notifyBtn'}},'查看详情')
            ]),
            duration: 0,
            type:'warning',
            offset: 90
        });

        let currentRoute = (that as any).$router.history.current;
        let msgRoute = ' ';
        switch(that.orderMessage.order.type){
            case 1:
                msgRoute = 'trade-list';
                break;
            case 2:
                msgRoute = 'offline-order';
                break;
            case 3:
                msgRoute = 'self-order';
                break;
            case 4:
                msgRoute = 'play-order';
                break;
            case 11:
                msgRoute = 'quick-index';
                break;
        }
        if(currentRoute.name == msgRoute){
            (that as any).$bus.$emit(msgRoute+'-getNewOrder',that.orderMessage);
        }



        let dom = document.getElementById('notifyBtn');
        if (dom) {
            dom.addEventListener('click', () => {
                // UserModule.setMsgRead(that.orderMessage.order.id);
                let current = (that as any).$router.history.current;
                   if(that.orderMessage.order){
                       let route = that.orderMessage.order?.type == 1 ? 'trade-list' : 'offline-order';
                       if(that.orderMessage.order?.route && that.orderMessage.order?.route!==''){
                           route = that.orderMessage.order.route;
                       }

                       if (current.name != route) {
                           (that as any).$router.push({
                               name: route,
                               query: {
                                   order_id: that.orderMessage.order.id,
                               },
                           });
                       } else {
                           (that as any).$bus.$emit(route + '-getNewOrder', that.orderMessage);
                       }
                   }

                UserModule.SET_ORDER_MESSAGE({});
                notify.close();
            })
        }
    }
}
